export default function toTree(list) {
  // 1. 定义两个中间变量
  const treeList = [] // 最终要产出的树状数据的数组
  const map = {} // 存储映射关系

  // 2. 建立一个映射关系，并给每个元素补充children属性.
  // 映射关系: 目的是让我们能通过id快速找到对应的元素
  // 补充children：让后边的计算更方便
  list.forEach((item) => {
    if (!item.children && item.isParent === '1') {
      item.children = []
    }
    map[item.id] = item
  })
  // 3. 循环
  list.forEach((item) => {
    // 对于每一个元素来说，先找它的上级
    //    如果能找到，说明它有上级，则要把它添加到上级的children中去
    //    如果找不到，说明它没有上级，直接添加到 tree3List
    const parent = map[item.fatherId]
    if (parent) {
      parent.children.push(item)
    } else {
      treeList.push(item)
    }
  })
  // 4. 返回出去
  return treeList
}
